export default __webpack_public_path__ + "static/media/appertflow-isotipo.2d0a9ddf.png";